import { Box, Grid, Typography } from "@mui/material";
import Reac from "react";
import { useFormContext } from "react-hook-form";
import {
  useDetector,
  useEquipment,
  useUser,
} from "@services/servicesGenericsTables";
import { useLaboratory } from "@services/servicesGenericsTables/useLaboratory";
import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import { useTypesUnits } from "@services/servicesGenericsTables/useTypesUnits";
import useFilteredProcedures from "@app/pages/samples/hook/useFilteredProcedures";
import {
  MAutocomplete,
  MButton,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import ResultsTable from "../commonForms/resultsTable";
import dayjs from "dayjs";
import { PROCESS_OPTIONS_VALUE } from "@app/pages/background/utils/constans";
import { useBackgroundCodes } from "@services/servicesGenericsTables/useBackgroundCodes";

const CalculationAlfaTotal = () => {
  const form = useFormContext();
  const { userList } = useUser();
  const { equipmentList } = useEquipment();
  const { laboratoriesList } = useLaboratory();
  const { currentCalculation, saveCalculate, loadingResults } = useAnalysis();
  const { typesUnitsis } = useTypesUnits();
  const { detectorsList } = useDetector();
  const filteredCalculation = useFilteredProcedures("CAL");
  const { backgroundCodesList } = useBackgroundCodes();

  const codeAnalysis = form.getValues("typeAnalysis")?.codigo;

  const handleCalculate = async () => {
    await saveCalculate(codeAnalysis as string);
  };

  const textButtonCalculation = "Calcular";

  return (
    <>
      {currentCalculation.index !== undefined && (
        <>
          <ResponsiveFormContainer columns={3}>
            <MAutocomplete
              key="calculation_analyst"
              name="calculation_analyst"
              options={userList}
              label="Seleccione un analista"
              getOptionLabel={(option) => option.username || ""}
              validation={{ required: "El analista es requerido" }}
            />
            <MDatePicker
              key="start_date_time"
              name="start_date_time"
              pickerType="datetime"
              label="Fecha y hora de inicio Toma de muestra"
              disabled
            />
            <MDatePicker
              key="end_date_time"
              name="end_date_time"
              pickerType="datetime"
              label="Fecha y hora fin Toma de muestra"
              disabled
            />
          </ResponsiveFormContainer>

          <Grid item xs={12} my={2}>
            <Typography variant="tagText">
              {"Datos ficha del procesamiento, preparación y contaje:"}
            </Typography>
          </Grid>

          <ResponsiveFormContainer columns={3}>
            <MTextField
              key={JSON.stringify(form.getValues("calculation_amount_sample"))}
              label="Cantidad de muestra"
              name="calculation_amount_sample"
              type="text"
              disabled
              fullWidth
            />
            <MAutocomplete
              key={JSON.stringify(form.getValues("calculation_units"))}
              name="calculation_units"
              options={typesUnitsis}
              label="Unidades"
              getOptionLabel={(option) =>
                `${option.codigo} | ${option.descripcion}`
              }
              disabled
            />
            <MTextField
              key={JSON.stringify(form.getValues("calculation_tsie_white"))}
              name="calculation_tsie_white"
              label="Peso precipitado (mg)"
              type="text"
              disabled
              fullWidth
            />
            <MTextField
              key={JSON.stringify(form.getValues("calculation_tsie_sample"))}
              name="calculation_tsie_sample"
              label="Peso Húmedo/ Seco"
              type="text"
              disabled
              fullWidth
            />
            <MAutocomplete
              key={JSON.stringify(form.getValues("calculation_equipment"))}
              name="calculation_equipment"
              options={equipmentList}
              label="Equipo de Contaje"
              getOptionLabel={(option) =>
                `${option.codigo} - ${option.descripcion}` || ""
              }
              disabled
              multiple={true}
            />
            <MAutocomplete
              key={JSON.stringify(form.getValues("calculation_detector"))}
              name="calculation_detector"
              options={detectorsList}
              label="Detector"
              getOptionLabel={(option) => `${option.name}` || ""}
              disabled
              multiple
            />
            <MDatePicker
              name="calculation_counting_date"
              pickerType="datetime"
              label="Fecha contaje"
              disabled
            />
            <MTextField
              key={JSON.stringify(form.getValues("total_time_counting"))}
              name="total_time_counting"
              label="Tiempo total contaje (min)"
              type="text"
              disabled
              fullWidth
            />
            <MTextField
              key={JSON.stringify(
                form.getValues("calculation_total_cpm_sample")
              )}
              name="calculation_total_cpm_sample"
              label="cpm brutas de la muestra"
              type="text"
              disabled
              fullWidth
            />
          </ResponsiveFormContainer>

          <Grid item xs={12} my={2}>
            <Typography variant="tagText">{"Datos a cumplimentar:"}</Typography>
          </Grid>

          <ResponsiveFormContainer columns={4}>
            <MAutocomplete
              key={JSON.stringify(form.getValues("laboratory"))}
              name="laboratory"
              options={laboratoriesList}
              label="Seleccione un Laboratorio"
              getOptionLabel={(option) =>
                `${option.codigo} - ${option.descripcion}` || ""
              }
              validation={{ required: "El laboratorio es requerido" }}
            />

            <MAutocomplete
              key={JSON.stringify(form.getValues("calculation_procedure"))}
              name="calculation_procedure"
              options={filteredCalculation}
              label="Procedimiento MLPMA"
              getOptionLabel={(option) => `${option.numop}` || ""}
              disabled
            />
            <MAutocomplete
              key={JSON.stringify(form.getValues("calculation_fondo"))}
              name="calculation_fondo"
              options={backgroundCodesList.filter(
                (fondo) => fondo.proceso === PROCESS_OPTIONS_VALUE.ALFA
              )}
              label="Fondo Beta"
              getOptionLabel={(option) =>
                `${option.proceso} - ${option.tipo_codigo}${
                  option.medio_filtro ? ` - ${option.medio_filtro}` : ""
                }` || ""
              }
              validation={{ required: "El fondo es requerido" }}
            />
            <MDatePicker
              name="calculation_date"
              pickerType="datetime"
              label="Fecha Cálculo"
              // minDate={dayjs(form.watch("calculation_counting_date"))}
            />
          </ResponsiveFormContainer>

          {currentCalculation.id !== undefined && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 2,
              }}
            >
              <MButton
                onClick={handleCalculate}
                text={textButtonCalculation}
                color="secondary"
                loading={loadingResults}
                disabled={!!form.watch("idResultPreload")}
              />
            </Box>
          )}

          <ResultsTable />
        </>
      )}
    </>
  );
};

export default CalculationAlfaTotal;
